import React, {useEffect, useState} from 'react';
import {instanceMob} from "../../../utils/utils";
import "./styles.css";
import {useModalManager} from "./utils/useModalManager";
import PlanFormModal from "./utils/plan-form-modal";
import InlineModal from "../../info-modal/infoModal";
import Tooltip from "../../tooltip/tooltip";
import PlanDetailModal from "./utils/plan-detail-modal";

const PlansListPanel = () => {
    const [plans, setPlans] = useState([]);
    const [filteredPlans, setFilteredPlans] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [modalMode, setModalMode] = useState(null);

    const ITEMS_PER_PAGE = 15;
    const totalPages = Math.ceil(filteredPlans.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const currentPlans = filteredPlans.slice(startIndex, endIndex);

    const {activeModal, modalData, openModal, closeModal} = useModalManager();

    const getPlans = async () => {
        instanceMob
            .get(`admin/plan?no_paginate=True`)
            .then((res) => res.data)
            .then((data) => {
                setPlans(data);
                setFilteredPlans(data);
            })
            .catch((err) => console.error(err));
    };

    const deletePlan = async () => {
        try {
            await instanceMob.delete(`admin/plan/${modalData}`);
            await getPlans();
            setCurrentPage(1);
            closeModal();
        } catch (error) {
            const errorMessage = error?.response?.data?.[0] || "Ocurrió un error al eliminar el plan";
            openModal('InlineErrorModal', errorMessage);
            console.error("Error al eliminar el plan:", error);
            throw error;
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleFormModal = (data, mode) => {
        setModalMode(mode)
        openModal('PlanFormModal', data);
    };

    const handleDeleteModal = (id) => {
        openModal('DeleteModal', id);
    };

    const handleDetailModal = (plan) => {
        openModal('PlanDetailModal', plan);
    };

    useEffect(() => {
        getPlans();
    }, []);

    useEffect(() => {
        const filtered = plans.filter(plan => plan.name.toLowerCase().includes(searchTerm.toLowerCase()));
        setFilteredPlans(filtered);
        setCurrentPage(1);
    }, [searchTerm, plans]);

    return (
        <>
            <div
                className="plans-list-panel-container w-100 h-100 d-flex flex-column justify-content-start align-self-start text-center p-3 gap-3">
                <div
                    className="plans-list-panel-top w-100 px-2 d-flex flex-row justify-content-between align-items-center">
                    <span className="plans-list-panel-title">Planes</span>
                    <button
                        className="plans-list-panel-button button btn btn-primary"
                        onClick={() => {
                            handleFormModal(null, "add")
                        }}
                    >
                        Agregar plan +
                    </button>
                </div>
                <div>
                    <div className="position-relative">
                        <input
                            type="text"
                            className="plans-list-panel-input"
                            placeholder="Buscar usuario"
                            aria-label="Buscar usuario"
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />

                    </div>
                </div>
                <div className="plans-list-panel-table w-100">
                    <div className="table-responsive">
                        <table className="table table-sm table-borderless align-middle mb-0">
                            <thead className="sticky-top bg-white">
                            <tr>
                                <th scope="col" className="plans-list-panel-table-labels text-start">Nombre</th>
                                <th scope="col" className="text-end"></th>
                            </tr>
                            </thead>
                        </table>
                        <div className="plans-list-panel-scroll-body">
                            <table className="table table-sm table-hover table-borderless align-middle mb-0">
                                <tbody>
                                {currentPlans.map((plan) => (<tr key={plan.id}>
                                    <td className="plans-list-panel-name-cell plans-list-panel-table-labels text-start">{plan.name}</td>
                                    <td className="text-end d-flex gap-1 justify-content-end">
                                        <Tooltip title="Ver detalle">
                                            <svg onClick={() => {handleDetailModal(plan) }} className="bi cursor-pointer" width="20" height="20"
                                                 viewBox="0 0 22 22"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="10.845" cy="10.9193" r="10.2747" fill="#B5C1CD"/>
                                            <path
                                                d="M11.7124 13.2469C11.3585 13.443 10.9978 13.5943 10.6135 13.6827C9.23134 13.9994 7.97023 13.7354 6.85402 12.859C6.01381 12.1983 5.47725 11.3309 5.2964 10.2794C5.01027 8.61533 5.51564 7.21226 6.80025 6.10752C7.412 5.58189 8.13039 5.25962 8.92903 5.15977C10.5779 4.95347 11.9422 5.49692 12.9937 6.78794C13.4619 7.36289 13.7431 8.02988 13.8587 8.76157C14.0126 9.73496 13.8587 10.661 13.3899 11.5313C13.3593 11.5882 13.3632 11.6195 13.4088 11.6654C14.22 12.4732 15.0272 13.2845 15.84 14.0917C16.0849 14.3338 16.2319 14.6158 16.2355 14.9632C16.2404 15.4239 15.9556 15.857 15.5385 16.0345C15.0908 16.2252 14.6018 16.1349 14.2508 15.7872C13.7637 15.305 13.2809 14.8187 12.7965 14.3338C12.4363 13.9735 12.0765 13.6122 11.7124 13.2469ZM9.55922 12.6529C11.3412 12.6422 12.7456 11.2247 12.7537 9.47715C12.762 7.69858 11.3362 6.29087 9.59999 6.27305C7.83186 6.25474 6.39137 7.6666 6.37672 9.43272C6.36208 11.2042 7.77467 12.6363 9.55922 12.6529Z"
                                                fill="white"/>
                                            <path
                                                d="M9.51027 7.13339C9.88051 7.1185 10.1132 7.39438 10.1427 7.66488C10.1759 7.96811 9.93648 8.26791 9.6313 8.29745C9.49349 8.31039 9.35164 8.31747 9.22054 8.35678C8.73891 8.5018 8.42861 8.92025 8.40724 9.43246C8.39522 9.7225 8.24703 9.93515 8.00301 10.0138C7.62557 10.1353 7.24367 9.85409 7.2422 9.45395C7.23842 8.48715 7.86794 7.59604 8.78499 7.27524C8.90254 7.23398 9.02419 7.20175 9.1465 7.17831C9.26613 7.15487 9.38893 7.14755 9.51027 7.13339Z"
                                                fill="white"/>
                                            </svg>
                                        </Tooltip>

                                        <Tooltip title="Editar">
                                            <svg onClick={() => {handleFormModal(plan.id, "add") }} className="bi cursor-pointer" width="20" height="20"
                                                 viewBox="0 0 20 20"
                                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M8.57275 19.5251C6.67188 19.5251 4.77087 19.5255 2.87012 19.5251C1.56775 19.5243 0.691895 18.6498 0.691772 17.349C0.691284 13.5402 0.691284 9.73258 0.691772 5.92423C0.691772 4.62076 1.56616 3.74747 2.86902 3.74698C5.87024 3.74649 8.87183 3.74576 11.8733 3.75089C12.0455 3.75089 12.1621 3.69888 12.2821 3.57852C13.1309 2.71915 13.9868 1.86734 14.8413 1.01407C15.777 0.0802326 16.9954 0.0785236 17.9358 1.00968C18.3673 1.43692 18.7968 1.86685 19.2246 2.29776C20.1355 3.21695 20.1349 4.44644 19.2229 5.36222C18.3605 6.22721 17.4976 7.09268 16.6283 7.95157C16.511 8.06729 16.4698 8.1835 16.47 8.34415C16.4744 11.3669 16.4747 14.3888 16.4724 17.4115C16.4716 18.4079 15.8688 19.2108 14.9323 19.4528C14.7281 19.506 14.5094 19.5219 14.2969 19.5226C12.3885 19.5273 10.4808 19.5251 8.57275 19.5251ZM15.0995 9.49991C15.0109 9.58365 14.9547 9.63394 14.9009 9.68717C13.198 11.3888 11.4979 13.0946 9.78723 14.789C9.63831 14.9364 9.42871 15.0563 9.22644 15.1095C7.6405 15.5304 6.04932 15.9323 4.45923 16.3373C4.34998 16.3647 4.23132 16.3857 4.12122 16.373C3.64917 16.318 3.40076 15.8808 3.56702 15.3974C4.07568 13.9128 4.58447 12.4281 5.10657 10.9486C5.17261 10.7609 5.28772 10.5727 5.42761 10.432C7.12415 8.72281 8.82874 7.02262 10.5316 5.31998C10.5851 5.26676 10.636 5.21036 10.7207 5.12003H10.474C7.93701 5.12003 5.40051 5.12003 2.86353 5.12076C2.32312 5.12076 2.06567 5.38053 2.06567 5.92423C2.06531 9.73258 2.06531 13.5402 2.06567 17.3483C2.06567 17.8876 2.32776 18.151 2.86523 18.151C6.67419 18.1515 10.4828 18.1515 14.2916 18.1515C14.8442 18.151 15.0989 17.8937 15.0991 17.3346C15.0995 14.8053 15.0995 12.2763 15.0995 9.74771C15.0995 9.67935 15.0995 9.61124 15.0995 9.49991ZM14.4574 3.44986C11.9038 6.00235 9.33569 8.56998 6.78296 11.1212C7.55078 11.8898 8.33704 12.6759 9.0968 13.4369C11.6561 10.8786 14.2239 8.31119 16.7711 5.7648C16.0028 4.99552 15.2169 4.20963 14.4574 3.44986ZM6.03674 12.4691C5.78784 13.1925 5.53552 13.9254 5.2666 14.7065C6.10217 14.4926 6.88745 14.2914 7.66003 14.0941C7.11121 13.5448 6.57971 13.0126 6.03674 12.4691Z"
                                                fill="#9DACBD"/>
                                            </svg>
                                        </Tooltip>

                                        <Tooltip title="Eliminar">
                                            <svg onClick={() => handleDeleteModal(plan.id)} className="bi bi-trash3-fill cursor-pointer"
                                                 xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                 fill="#B5C1CD"
                                                 viewBox="0 0 16 16">
                                            <path
                                                d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5"/>
                                            </svg>
                                        </Tooltip>

                                    </td>
                                </tr>))}
                                {currentPlans.length === 0 && (<tr>
                                    <td colSpan="2"
                                        className="plans-list-panel-table-labels text-center text-muted py-3">
                                        No se encontraron resultados.
                                    </td>
                                </tr>)}
                                </tbody>
                            </table>
                        </div>
                        <div
                            className="d-flex justify-content-end align-items-center mt-2 gap-4">
                            <span
                                className="plans-list-panel-table-labels">{startIndex + 1} - {Math.min(endIndex, filteredPlans.length)} de {filteredPlans.length}</span>
                            <div className="d-flex gap-2">
                                <svg
                                    className={`bi bi-chevron-left ${currentPage === 1 ? 'text-muted' : 'cursor-pointer'}`}
                                    onClick={handlePrevPage} xmlns="http://www.w3.org/2000/svg" width="9" height="15"
                                    viewBox="0 0 9 15" fill="none">
                                    <path
                                        d="M0.0423059 7.30351C0.0423059 6.92015 0.188535 6.53675 0.481072 6.24419L6.28647 0.438753C6.87147 -0.146251 7.81998 -0.146251 8.405 0.438753C8.99 1.02376 8.99 1.97231 8.405 2.55733L3.65881 7.30351L8.405 12.0497C8.99 12.6347 8.99 13.5832 8.405 14.1683C7.81998 14.7533 6.87147 14.7533 6.28647 14.1683L0.481072 8.36282C0.188535 8.0703 0.0423059 7.68685 0.0423059 7.30351Z"
                                        fill="#9DACBD"/>
                                </svg>
                                <svg
                                    className={`bi bi-chevron-right ${currentPage === totalPages ? 'text-muted' : 'cursor-pointer'}`}
                                    onClick={handleNextPage} xmlns="http://www.w3.org/2000/svg" width="10" height="15"
                                    viewBox="0 0 10 15" fill="none">
                                    <path
                                        d="M9.67644 7.30196C9.67644 7.68532 9.53022 8.06872 9.23768 8.36128L3.43228 14.1667C2.84728 14.7517 1.89877 14.7517 1.31375 14.1667C0.72875 13.5817 0.72875 12.6332 1.31375 12.0481L6.05994 7.30196L1.31375 2.55578C0.72875 1.97078 0.72875 1.02223 1.31375 0.437193C1.89877 -0.14781 2.84728 -0.14781 3.43228 0.437193L9.23768 6.24264C9.53022 6.53517 9.67644 6.91862 9.67644 7.30196Z"
                                        fill="#9DACBD"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {activeModal === 'PlanFormModal' && (
                <PlanFormModal
                    mode={modalMode}
                    data={modalData}
                    show
                    onClose={closeModal}
                    onSuccess={getPlans}
                />
            )}

            {activeModal === 'DeleteModal' && (
                <InlineModal
                    show
                    title="¿Deseas eliminar este plan?"
                    primaryAction={{
                        label: "Confirmar",
                        onClick: deletePlan,
                    }}
                    secondaryAction={{
                        label: "Cancelar",
                        onClick: closeModal
                    }}

                />
            )}

            {activeModal === 'InlineErrorModal' && (
                <InlineModal
                    show
                    title="Error"
                    description={modalData}
                    primaryAction={{
                        label: "Cerrar",
                        onClick: closeModal
                    }}
                />
            )}

            {activeModal === 'PlanDetailModal' && (
                <PlanDetailModal show plan={modalData} onClose={closeModal}/>
            )}


        </>
    );
};

export default PlansListPanel;
